import type { VerticalData } from './vertical';

export const rslMediaTypeData = [
  {
    name: 'Digital',
    lowerQuartile: '3.9%',
    median: '12.8%',
    upperQuartile: '28.3%',
  },
  {
    name: 'TV',
    lowerQuartile: '1.7%',
    median: '13.5%',
    upperQuartile: '25.2%',
  },
  {
    name: 'OOH*',
    lowerQuartile: '38.2%',
    median: '41.6%',
    upperQuartile: '45.2%',
  },
] as const satisfies readonly VerticalData[];

export const rslDigitalVerticalData = [
  {
    name: 'Dining',
    lowerQuartile: '7.9%',
    median: '16.2%',
    upperQuartile: '37.0%',
  },
  {
    name: 'Retail',
    lowerQuartile: '2.6%',
    median: '8.7%',
    upperQuartile: '19.2%',
  },
] as const satisfies readonly VerticalData[];

export const rslDigitalSubverticalData = [
  {
    name: 'Dining - Fast Casual',
    lowerQuartile: '9.7%',
    median: '16.2%',
    upperQuartile: '37.6%',
  },
  {
    name: 'Dining - QSR',
    lowerQuartile: '6.5%',
    median: '16.5%',
    upperQuartile: '33.9%',
  },
  {
    name: 'Retail - Big Box*',
    lowerQuartile: '10.0%',
    median: '15.1%',
    upperQuartile: '21.9%',
  },
  {
    name: 'Retail - Clothing',
    lowerQuartile: '0.0%',
    median: '16.9%',
    upperQuartile: '20.5%',
  },
  {
    name: 'Retail - Convenience',
    lowerQuartile: '7.0%',
    median: '9.5%',
    upperQuartile: '13.1%',
  },
  {
    name: 'Retail - Drug*',
    lowerQuartile: '26.4%',
    median: '28.5%',
    upperQuartile: '29.7%',
  },
  {
    name: 'Retail - Grocery',
    lowerQuartile: '1.6%',
    median: '4.4%',
    upperQuartile: '8.3%',
  },
  {
    name: 'Retail - Home Improvement*',
    lowerQuartile: '0.0%',
    median: '1.7%',
    upperQuartile: '11.6%',
  },
] as const satisfies readonly VerticalData[];
